import type { APIPropExpanded } from '../interfaces/propsService/api';
import type { TPropExpanded } from '../interfaces/propsService/parsed/props';

const parsePropExpanded = (response: APIPropExpanded): TPropExpanded => ({
  ...response,
  game_start: new Date(response.game_start),
  score: response.score ?? 0,
});

export default parsePropExpanded;
